<template>
  <div class="flex w-full flex-col items-center justify-center space-y-1">
    <icon-base :icon="IconHourglass" width="120" height="120" />
    <lf-h4>
      {{ $t("DEALS.DEAL_PROGRESS.UNDERWRITING.CFA_PROCESSING") }}
    </lf-h4>
    <span>
      {{ $t("DEALS.DEAL_PROGRESS.UNDERWRITING.CFA_PLEASE_WAIT") }}
    </span>
    <div v-if="showWaitingTime" class="flex justify-center space-x-2">
      <icon-base :icon="IconClock" />
      <span>
        {{ $t("DEALS.DEAL_PROGRESS.UNDERWRITING.CFA_WAIT_TIME") }}
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconClock from "@/components/icons/IconClock.vue";
import IconHourglass from "@/components/icons/IconHourglass.vue";

interface Props {
  showWaitingTime?: boolean;
}

withDefaults(defineProps<Props>(), { showWaitingTime: true });
</script>
